export var TITLE = 'Meta';
export var TEXT_MULTIPLE = 0.75;
export var SPACE_MULTIPLE = 0.2;
export var COLOR_PRIMARY = '#1d65c1';
export var COLOR_GRADIENT = 'linear-gradient(45deg, #007FF8, #0668E1, #007FF8)';